<!-- iPhoneのソフトウェアキーボードでマイナスキーが無く -->
<!-- 負の値が入力できないという問題があったため自前でキーボードを実装している -->
<script setup lang="ts">
import type { Key } from './NumericKeyboardKey.vue'

import BackspaceIcon from '~/components/atoms/icons/BackspaceIcon.vue'
import NumericKeyboardKey from '~/components/foundations/NumericKeyboard/NumericKeyboardKey.vue'

export type { Key }

const emits = defineEmits<{
  (e: 'done'): void
  (e: 'keyPress', value: Key): void
}>()

const keyPress = (value: Key) => {
  emits('keyPress', value)
}
</script>

<template>
  <div class="numeric-keyboard">
    <NumericKeyboardKey class="key grid-item-base" :value="'1'" @key-press="keyPress" />
    <NumericKeyboardKey class="key grid-item-base" :value="'2'" @key-press="keyPress" />
    <NumericKeyboardKey class="key grid-item-base" :value="'3'" @key-press="keyPress" />
    <NumericKeyboardKey class="key grid-item-base" :value="'4'" @key-press="keyPress" />
    <NumericKeyboardKey class="key grid-item-base" :value="'5'" @key-press="keyPress" />
    <NumericKeyboardKey class="key grid-item-base" :value="'6'" @key-press="keyPress" />
    <NumericKeyboardKey class="key grid-item-base" :value="'7'" @key-press="keyPress" />
    <NumericKeyboardKey class="key grid-item-base" :value="'8'" @key-press="keyPress" />
    <NumericKeyboardKey class="key grid-item-base" :value="'9'" @key-press="keyPress" />
    <NumericKeyboardKey class="key grid-item-half" :value="'-'" @key-press="keyPress" />
    <NumericKeyboardKey class="key grid-item-half" :value="'.'" @key-press="keyPress" />
    <NumericKeyboardKey class="key grid-item-base" :value="'0'" @key-press="keyPress" />
    <button class="backspace-key grid-item-base" @click="keyPress('backspace')">
      <BackspaceIcon :size="18" />
    </button>
  </div>
</template>

<style lang="scss" scoped>
.numeric-keyboard {
  // iPhone等で勝手にズームされてしまう挙動の体験がよくないためtouch-actionを指定している
  touch-action: manipulation;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(4, 1fr);
  gap: spacingToken.$spacing-xs;
}

.backspace-key {
  background-color: transparent;
  border: none;
  border-radius: 4px;
  height: 48px;

  &:hover {
    background-color: var(--semantic-tokens-neutral-xweak-surface);
  }
}

.grid-item-base {
  grid-column: span 2;
}

.grid-item-half {
  grid-column: span 1;
}

.top-area {
  height: 40px;

  button {
    border: none;
    background-color: transparent;

    &:hover {
      background-color: var(--semantic-tokens-neutral-xweak-surface);
    }
  }
}
</style>
